import store from '~/javascripts/store.js';

export default (el, { expression }, { cleanup }) => {
  const amount = expression;

  const onClick = () => {
    store.donateForm.isSubscription = false;
    store.donateForm.showOtherAmountInput = true;
    store.donateForm.isWpsAmountButtonSelected = false;
    store.donateForm.amount = amount;
    store.donateForm.setSelectedPaymentTab();
    window.track_event('Complete the Goal Button Click');
  };

  el.addEventListener('click', onClick);
  cleanup(() => el.removeEventListener('click', onClick));
};
